import { render, staticRenderFns } from "./compare.component.html?vue&type=template&id=559fac19&scoped=true&"
import script from "./compare.component.js?vue&type=script&lang=js&"
export * from "./compare.component.js?vue&type=script&lang=js&"
import style0 from "./compare.component.scss?vue&type=style&index=0&id=559fac19&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559fac19",
  null
  
)

export default component.exports